export default {"src":"/_next/static/media/soy.bda50b77.svg","height":671,"width":671,"blurWidth":0,"blurHeight":0};